// Count filter checked — inclut les checkboxes hors DOM du form (via attribut form="collectionFacetsForm")
function getFormCheckboxes() {
	return document.querySelectorAll('input[type="checkbox"][form="collectionFacetsForm"], #collectionFacetsForm input[type="checkbox"]');
}

function updateCheckedCount() {
	const checkedCount = document.querySelectorAll(
		'input[type="checkbox"][form="collectionFacetsForm"]:checked, #collectionFacetsForm input[type="checkbox"]:checked'
	).length;

	const countElement = document.getElementById('checked-count');
	if (countElement) {
		countElement.textContent = checkedCount;
		countElement.style.display = checkedCount > 0 ? '' : 'none';
	}

	const countElementSticky = document.getElementById('checked-count-sticky');
	if (countElementSticky) {
		countElementSticky.textContent = checkedCount;
		countElementSticky.style.display = checkedCount > 0 ? '' : 'none';
	}
}

function setupFilterCountListeners() {
	const checkboxes = getFormCheckboxes();

	checkboxes.forEach(function (checkbox) {
		checkbox.removeEventListener('change', updateCheckedCount);
		checkbox.addEventListener('change', updateCheckedCount);
	});

	// Update count immediately
	updateCheckedCount();
}

document.addEventListener('DOMContentLoaded', function () {
	setupFilterCountListeners();
});



function getActiveFilterForm() {
	// Sur mobile (<1125px) : le form du hero ; sur desktop : celui de la grid
	if (window.innerWidth < 1125) {
		var heroForm = document.getElementById('collectionFacetsFormHero');
		if (heroForm) return heroForm;
	}
	return document.getElementById('collectionFacetsForm');
}

function initAccordeonsProductForm() {
	var form = getActiveFilterForm();
	if (!form) return;
	var contents = form.querySelectorAll('.mm-plp-r');
	var headers = form.querySelectorAll('.mm-plp-q');

	contents.forEach(function(content){
		content.dataset.height = content.offsetHeight;
		content.style.maxHeight = "0";
	});

	// Ouvrir Localisation par défaut
	headers.forEach(function(header){
		var label = header.querySelector('.mm-plp-question');
		if (label && label.textContent.trim() === 'Localisation') {
			header.classList.add('mm-open');
			header.nextElementSibling.style.maxHeight = header.nextElementSibling.dataset.height + "px";
		}
		header.addEventListener('click', function(e){
			var isOpen = header.classList.contains('mm-open');
			headers.forEach(function(h){
				h.classList.remove('mm-open');
				h.nextElementSibling.style.maxHeight = "0px";
			});
			if (!isOpen) {
				header.classList.add('mm-open');
				header.nextElementSibling.style.maxHeight = header.nextElementSibling.dataset.height + "px";
			}
		});
	});
}

function reloadAccordeonsProductForm(openGroups) {
	var form = getActiveFilterForm();
	if (!form) return;
	var contents = form.querySelectorAll('.mm-plp-r');
	var headers = form.querySelectorAll('.mm-plp-q');

	contents.forEach(function(content){
		var wasOpen = content.previousElementSibling && content.previousElementSibling.classList.contains('mm-open');
		content.style.maxHeight = 'none';
		content.style.display = 'block';
		var height = content.scrollHeight;
		content.dataset.height = height;
		if (wasOpen) {
			content.style.maxHeight = height + "px";
		} else {
			content.style.maxHeight = "0";
		}
	});

	// Réattacher les event listeners
	headers.forEach(function(header){
		var newHeader = header.cloneNode(true);
		header.parentNode.replaceChild(newHeader, header);
	});

	var newHeaders = form.querySelectorAll('.mm-plp-q');

	// Restaurer les groupes ouverts passés en paramètre, sinon ouvrir Localisation par défaut
	if (openGroups && openGroups.size > 0) {
		newHeaders.forEach(function(header){
			var groupName = header.closest('.mm-plp-c') && header.closest('.mm-plp-c').dataset.name;
			if (groupName && openGroups.has(groupName)) {
				header.classList.add('mm-open');
				var r = header.nextElementSibling;
				if (r) r.style.maxHeight = r.dataset.height + "px";
			}
		});
	} else {
		// Ouvrir Localisation par défaut si aucun groupe à restaurer
		var anyOpen = false;
		newHeaders.forEach(function(h){ if (h.classList.contains('mm-open')) anyOpen = true; });
		if (!anyOpen) {
			newHeaders.forEach(function(header){
				var label = header.querySelector('.mm-plp-question');
				if (label && label.textContent.trim() === 'Localisation') {
					header.classList.add('mm-open');
					header.nextElementSibling.style.maxHeight = header.nextElementSibling.dataset.height + "px";
				}
			});
		}
	}

	newHeaders.forEach(function(header){
		header.addEventListener('click', function(e){
			var isOpen = header.classList.contains('mm-open');
			newHeaders.forEach(function(h){
				h.classList.remove('mm-open');
				h.nextElementSibling.style.maxHeight = "0px";
			});
			if (!isOpen) {
				header.classList.add('mm-open');
				header.nextElementSibling.style.maxHeight = header.nextElementSibling.dataset.height + "px";
			}
		});
	});
}

// Remonte lors du choix du filtre — uniquement pour les checkboxes de facettes,
// pas pour les autres cases de la page (ex : consentement newsletter du footer)
document.addEventListener("DOMContentLoaded", function () {
    document.body.addEventListener("change", function (event) {

	if (window.innerWidth > 1125) {
        var target = event.target;
        var isFacetCheckbox =
            target.matches("input[type='checkbox']") &&
            (target.getAttribute("form") === "collectionFacetsForm" ||
             (target.form && target.form.id === "collectionFacetsForm") ||
             target.closest("#collectionFacetsForm"));

        if (isFacetCheckbox) {

            setTimeout(() => {
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            }, 50);
        }
	}
    });
});

document.addEventListener("DOMContentLoaded", (event) => {
	initAccordeonsProductForm();
});
